export default __webpack_public_path__ + "static/media/arrow-next-small.2f045bce.svg";